import React from 'react';
import { Github, Book, Code, History, Users, ExternalLink, Rocket } from 'lucide-react';

function About() {
  const teamMembers = [
    {
      name: "Shashikant Maurya",
      role: "Backend Developer",
      github: "https://github.com/shashikant190",
      description: "Lead developer responsible for database architecture and frontend integration"
    },
    {
      name: "Saurabh Sav",
      role: "Full Stack Developer",
      github: "https://github.com/AkiraYuki-04",
      description: "Lead developer specialist focusing on AI integration and backend architecture"
    }
  ];

  return (
    <div className="min-h-screen bg-parchment pt-16 font-serif">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex justify-center mb-4">
            <Book className="h-16 w-16 text-parchment-dark" />
          </div>
          <h1 className="vintage-title">About Our Journey</h1>
          <p className="vintage-subtitle max-w-3xl mx-auto">
            Discover the story behind our mission to make history learning interactive and engaging
          </p>
        </div>

        {/* Project Description */}
        <div className="vintage-card mb-12">
          <h2 className="text-2xl font-bold text-parchment-dark mb-6 flex items-center gap-2">
            <History className="h-6 w-6" />
            Our Mission
          </h2>
          <p className="text-parchment-dark/80 leading-relaxed mb-6">
            AI History Tutor is an innovative platform designed to revolutionize how people learn and interact with historical knowledge. By combining artificial intelligence with interactive learning tools, we create an engaging environment where history comes alive through conversations, timelines, maps, and quizzes.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
            <div className="p-4 bg-parchment rounded-lg border-2 border-parchment-dark/20">
              <h3 className="font-bold text-parchment-dark mb-2">Interactive Learning</h3>
              <p className="text-parchment-dark/80">Engage with history through AI-powered conversations and dynamic visualizations</p>
            </div>
            <div className="p-4 bg-parchment rounded-lg border-2 border-parchment-dark/20">
              <h3 className="font-bold text-parchment-dark mb-2">Global Perspective</h3>
              <p className="text-parchment-dark/80">Explore historical events from different regions and time periods</p>
            </div>
            <div className="p-4 bg-parchment rounded-lg border-2 border-parchment-dark/20">
              <h3 className="font-bold text-parchment-dark mb-2">Adaptive Learning</h3>
              <p className="text-parchment-dark/80">Personalized quizzes and feedback to enhance your understanding</p>
            </div>
          </div>
        </div>

        {/* Team Section */}
        <div className="vintage-card mb-12">
          <h2 className="text-2xl font-bold text-parchment-dark mb-6 flex items-center gap-2">
            <Users className="h-6 w-6" />
            Meet the Team
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {teamMembers.map((member, index) => (
              <div key={index} className="bg-parchment p-6 rounded-lg border-2 border-parchment-dark/20">
                <h3 className="text-xl font-bold text-parchment-dark mb-2">{member.name}</h3>
                <p className="text-parchment-dark/60 mb-3">{member.role}</p>
                <p className="text-parchment-dark/80 mb-4">{member.description}</p>
                <a
                  href={member.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-parchment-dark hover:text-parchment-dark/80 transition-colors"
                >
                  <Github className="h-5 w-5" />
                  View GitHub Profile
                  <ExternalLink className="h-4 w-4" />
                </a>
              </div>
            ))}
          </div>
        </div>

        {/* Technology Stack */}
        <div className="vintage-card mb-12">
          <h2 className="text-2xl font-bold text-parchment-dark mb-6 flex items-center gap-2">
            <Code className="h-6 w-6" />
            Technology Stack
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            <div className="p-4 bg-parchment rounded-lg border-2 border-parchment-dark/20">
              <h3 className="font-bold text-parchment-dark mb-2">Frontend</h3>
              <ul className="text-parchment-dark/80 space-y-1">
                <li>React</li>
                <li>TypeScript</li>
                <li>Tailwind CSS</li>
              </ul>
            </div>
            <div className="p-4 bg-parchment rounded-lg border-2 border-parchment-dark/20">
              <h3 className="font-bold text-parchment-dark mb-2">Backend</h3>
              <ul className="text-parchment-dark/80 space-y-1">
                <li>Python</li>
                <li>Flask</li>
               
              </ul>
            </div>
            <div className="p-4 bg-parchment rounded-lg border-2 border-parchment-dark/20">
              <h3 className="font-bold text-parchment-dark mb-2">Database & Models</h3>
              <ul className="text-parchment-dark/80 space-y-1">
                <li>Supabase</li>
                <li>GPT-3.5 Turbo</li>
            
              </ul>
            </div>
            <div className="p-4 bg-parchment rounded-lg border-2 border-parchment-dark/20">
              <h3 className="font-bold text-parchment-dark mb-2">APIs</h3>
              <ul className="text-parchment-dark/80 space-y-1">
              <li>WikipediaAPI</li>
              <li>OpenAI API</li>
              <li>WIKIDATA API</li>
              </ul>
            </div>
            <div className="p-4 bg-parchment rounded-lg border-2 border-parchment-dark/20">
              <h3 className="font-bold text-parchment-dark mb-2">Tools</h3>
              <ul className="text-parchment-dark/80 space-y-1">
                <li>Vite</li>
                <li>Git</li>
                <li>Railway</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Future Scope */}
        <div className="vintage-card">
          <h2 className="text-2xl font-bold text-parchment-dark mb-6 flex items-center gap-2">
            <Rocket className="h-6 w-6" />
            Future Scope
          </h2>
          <ul className="list-disc list-inside text-parchment-dark/80 space-y-4 leading-relaxed">
            <li>
              <strong>Real-time Feedback:</strong> We aim to integrate speech recognition and text-to-speech capabilities to enable verbal interaction, simulating human tutoring for a hands-free, immersive learning experience.
            </li>
            <li>
              <strong>Multilingual Support:</strong> Our goal is to expand into Hindi and other Indian regional languages, making historical education accessible across linguistic backgrounds.
            </li>
            <li>
              <strong>Expanded Content:</strong> We plan to enhance our dataset with deeper world history coverage, including archaeology and culture, supported by interactive maps, multimedia timelines, and primary source archives via Gemini’s multimodal tools.
            </li>
            <li>
              <strong>Advanced Personalization:</strong> By incorporating learning analytics, the platform will adaptively suggest topics and difficulty levels, helping users progress based on their performance.
            </li>
            <li>
              <strong>Gamified Achievements:</strong> We're exploring badges and leaderboards to boost engagement—designed with research-backed gamification that encourages collaboration and curiosity.
            </li>
            <li>
              <strong>Teacher Dashboard:</strong> We plan to introduce a dedicated teacher interface to monitor student progress and assign content, enabling effective blended learning models in classrooms.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default About;
